import messages from "@smartmixin/i18n/dist/translations/it.json";

export default messages;
